module.exports = __webpack_public_path__ + "assets/img/1.8561eb8e.png";